import { render, staticRenderFns } from "./Basement.vue?vue&type=template&id=c2e8a00a&scoped=true&"
import script from "./Basement.vue?vue&type=script&lang=js&"
export * from "./Basement.vue?vue&type=script&lang=js&"
import style0 from "./Basement.vue?vue&type=style&index=0&id=c2e8a00a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e8a00a",
  null
  
)

export default component.exports